export const ErrorFallback = () => {
    return <h1>Something went wrong</h1>;
  };
  